import { Component, OnInit } from "@angular/core";
import { DataService_ScanStationTrackingSU } from "./shared/data.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { ScanStationSuUpdateAllComponent } from "./scan-station-su-update-all/scan-station-su-update-all.component";
import { ConfirmationService } from "primeng/api";
import { ScanStationPrefRequest } from "./shared/ScanStationPrefRequest";

@Component({
	selector: "app-scan-station-tracking-su",
	templateUrl: "./scan-station-tracking-su.component.html",
	styleUrls: ["./scan-station-tracking-su.component.css"],
})
export class ScanStationTrackingSUComponent implements OnInit {
	constructor(
		private dataService: DataService_ScanStationTrackingSU,
		private selectService: SchoolselectorService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});

		this.loadCategories();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	subscription: any;

	SelectedSchool: any;

	SelectedFacility: any;
	lstFacility: any = [];
	LoadingFacility: boolean = false;

	ActiveOption: number = -1;
	lstActive: any = [
		{
			ID: -1,
			Desc: "Any",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Decommissioned",
		},
	];

	lstCategory: CategoryInfo[] = [];
	LoadingCategory: boolean = false;
	SelectedColumns: ColumnInfo[] = [];

	SelectedScanStations: any = [];
	lstScanStation: any = [];
	LoadingScanStation: boolean = false;

	Processing: boolean = false;

	//
	// Table
	//
	pagerows: any = 10;
	pagefirst: any = 0;
	errorMessage: any = "";

	//Filter lists
	lstFacilityName: any = [];
	lstFacilityLocationName: any = [];
	lstSchoolFullName: any = [];
	lstIsDecommissionedDesc: any = [];
	lstCurrentPackageVersion: any = [];
	lstSQLServerName: any = [];
	lstIsSeverRequestRebuildDesc: any = [];
	lstSYS_OS_Name: any = [];
	lstSYS_OS_Architecture: any = [];
	lstSYS_OS_Version: any = [];
	lstSYS_CPU_Name: any = [];
	lstSYS_CPU_Cores_Threads: any = [];
	lstEntryModeEnabledDesc: any = [];
	lstExitModeEnabledDesc: any = [];
	lstMealModeEnabledDesc: any = [];
	lstAccessModeEnabledDesc: any = [];
	lstTimeStampModeEnabledDesc: any = [];
	lstEventModeEnabledDesc: any = [];
	lstPrinterEnabledDesc: any = [];
	lstTurnstileEnabledDesc: any = [];
	lstLEDEnabledDesc: any = [];
	lstEnable4ChannelScanningDesc: any = [];
	lstOmniKeyOnlyDesc: any = [];

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	loadFacility() {
		this.LoadingFacility = true;
		var result = this.dataService.FacilitySelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.LoadingFacility = false;

				this.lstFacility = response;

				if (this.SelectedSchool.SchoolID <= 0) {
					this.lstFacility.unshift({
						FacilityID: -1,
						FacilityName: "All",
						FacilityFullName: "All",
					});
				}

				this.SelectedFacility = this.lstFacility[0];

				this.loadTableData();
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	loadCategories() {
		this.LoadingCategory = true;

		var result = this.dataService.ScanStationTrackingSUColumnOptionSelectList();
		result.subscribe(
			(response: any) => {
				this.LoadingCategory = false;

				// this.lstCategory = response;

				this.UpdateCategories(response);
			},
			(error) => {
				this.LoadingCategory = false;
			}
		);
	}

	UpdateCategories(lstCategory: any[]) {
		var AllCategories: CategoryInfo[] = [];

		var NextCategory: CategoryInfo = {
			Category: "",
			lstColumns: [],
		};

		for (var z = 0; z < lstCategory.length; z++) {
			var next = lstCategory[z];

			if (NextCategory.Category == "") {
				NextCategory.Category = next.Category;
			}

			if (next.Category != NextCategory.Category) {
				AllCategories = [...AllCategories, NextCategory];
				NextCategory = {
					Category: next.Category,
					lstColumns: [],
				};
			}

			var nextInfo: ColumnInfo = {
				ColumnName: next.ColumnName,
				Selected: next.Selected,
				ReadOnly: next.ReadOnly,
				DataField: next.DataField,
			};

			if (nextInfo.Selected == true) {
				this.SelectedColumns = [...this.SelectedColumns, nextInfo];
			}

			NextCategory.lstColumns = [...NextCategory.lstColumns, nextInfo];
		}

		AllCategories = [...AllCategories, NextCategory];

		this.lstCategory = AllCategories;

		console.log(this.lstCategory);
	}

	loadTableData() {
		this.errorMessage = "";

		this.LoadingScanStation = true;

		var result = this.dataService.ScanStationTrackingSUSelectList(this.SelectedFacility.FacilityID, this.ActiveOption);
		result.subscribe(
			(response) => {
				this.LoadingScanStation = false;

				this.lstScanStation = response;

				for (var z = 0; z < this.lstScanStation.length; z++) {
					var next = this.lstScanStation[z];
					next.NewSQLServerName = String(next.SQLServerName);
				}

				this.lstFacilityName = Array.from(new Set(this.lstScanStation.map((item: any) => item.FacilityName)));
				this.lstFacilityLocationName = Array.from(new Set(this.lstScanStation.map((item: any) => item.FacilityLocationName)));
				this.lstSchoolFullName = Array.from(new Set(this.lstScanStation.map((item: any) => item.SchoolFullName)));
				this.lstIsDecommissionedDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsDecommissionedDesc)));
				this.lstCurrentPackageVersion = Array.from(new Set(this.lstScanStation.map((item: any) => item.CurrentPackageVersion)));
				this.lstSQLServerName = Array.from(new Set(this.lstScanStation.map((item: any) => item.SQLServerName)));
				this.lstIsSeverRequestRebuildDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsSeverRequestRebuildDesc)));
				this.lstSYS_OS_Name = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_OS_Name)));
				this.lstSYS_OS_Architecture = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_OS_Architecture)));
				this.lstSYS_OS_Version = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_OS_Version)));
				this.lstSYS_CPU_Name = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_CPU_Name)));
				this.lstSYS_CPU_Cores_Threads = Array.from(new Set(this.lstScanStation.map((item: any) => item.SYS_CPU_Cores_Threads)));
				this.lstEntryModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EntryModeEnabledDesc)));
				this.lstExitModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.ExitModeEnabledDesc)));
				this.lstMealModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.MealModeEnabledDesc)));
				this.lstAccessModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.AccessModeEnabledDesc)));
				this.lstTimeStampModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.TimeStampModeEnabledDesc)));
				this.lstEventModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EventModeEnabledDesc)));
				this.lstPrinterEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.PrinterEnabledDesc)));
				this.lstTurnstileEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.TurnstileEnabledDesc)));
				this.lstLEDEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.LEDEnabledDesc)));
				this.lstEnable4ChannelScanningDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.Enable4ChannelScanningDesc)));
				this.lstOmniKeyOnlyDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.OmniKeyOnlyDesc)));
			},
			(error) => {
				this.LoadingScanStation = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////
	onRefresh() {
		this.loadTableData();
	}

	onUpdateAll() {
		this.errorMessage = "";

		if (this.SelectedScanStations.length == 0) {
			this.errorMessage = "Select ScanStations with the left check box to update multiple at a time";
			return;
		}

		var ref = this.dialogService.open(ScanStationSuUpdateAllComponent, {
			header: "Update All",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedScanStations: this.SelectedScanStations,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.SelectedScanStations = [];
				this.onRefresh();
			}
		});
	}

	onResetColOptions() {
		this.SelectedColumns = [];

		for (var a = 0; a < this.lstCategory.length; a++) {
			var cat = this.lstCategory[a];

			for (var b = 0; b < cat.lstColumns.length; b++) {
				var col = cat.lstColumns[b];

				if (col.Selected == true) {
					this.SelectedColumns = [...this.SelectedColumns, col];
				}
			}
		}
	}

	onSaveSqlServerName(ScanStation) {
		this.Processing = true;

		var parms: ScanStationPrefRequest = {
			KeyName: "SQLServerName",
			KeyValue: ScanStation.NewSQLServerName,
			ScanStation: ScanStation.ScanStation,
		};

		var result = this.dataService.UpdateScanStationPref(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "sstmain",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "SQL Server Name was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.onRefresh();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "sstmain",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update SQLServerName Preference: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadFacility();
	}

	onFacilityChange(val) {
		this.SelectedFacility = val;

		if (this.IsLoading() == false) {
			this.loadTableData();
		}
	}

	onActiveOptionChange(val) {
		this.ActiveOption = val;

		if (this.IsLoading() == false) {
			this.loadTableData();
		}
	}

	onUpdateDecommissioned(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == true) {
			Msg = "Decommissioning a ScanStation means it won't be usable anymore. Are you sure you want to decommission " + ss.ScanStation + "?";
		} else {
			Msg = "Are you sure you want to Re-commission " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm " + (val == true ? "Decommission" : "Re-Commission"),
			icon: "fa",
			accept: () => {
				this.onFinishUpdateDecommissioned(ss, val);
			},
			reject: () => {
				ss.IsDecommissioned = !val;
				if (ss.IsDecommissioned == true) {
					ss.IsDecommissionedDesc = "Yes";
				} else {
					ss.IsDecommissionedDesc = "No";
				}
			},
		});
	}

	onFinishUpdateDecommissioned(ss, val) {
		this.Processing = true;

		// ss.IsDecommissioned = val;
		// if (ss.IsDecommissioned == true) {
		// 	ss.IsDecommissionedDesc = "Yes";
		// } else {
		// 	ss.IsDecommissionedDesc = "No";
		// }
		// this.lstIsDecommissionedDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsDecommissionedDesc)));

		var result = this.dataService.ScanStationDecomissionUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					// ss.IsDecommissioned = !val;

					// if (ss.IsDecommissioned == true) {
					// 	ss.IsDecommissionedDesc = "Yes";
					// } else {
					// 	ss.IsDecommissionedDesc = "No";
					// }
					// this.lstIsDecommissionedDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsDecommissionedDesc)));
				} else {
					this.onRefresh();
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateEntryMode(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == false) {
			Msg = "Turning off Entry Mode means it will no longer show up in the menu. Are you sure you want to disable Entry Mode for " + ss.ScanStation + "?";
		} else {
			Msg = "Are you sure you want to turn on Entry Mode for " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Entry Mode",
			icon: "fa",
			accept: () => {
				this.onFinishUpdateEntryMode(ss, val);
			},
			reject: () => {
				ss.EntryModeEnabled = !val;
				if (ss.EntryModeEnabled == true) {
					ss.EntryModeEnabledDesc = "Yes";
				} else {
					ss.EntryModeEnabledDesc = "No";
				}
			},
		});
	}

	onFinishUpdateEntryMode(ss, val) {
		this.Processing = true;

		ss.EntryModeEnabled = val;
		if (ss.EntryModeEnabled == true) {
			ss.EntryModeEnabledDesc = "Yes";
		} else {
			ss.EntryModeEnabledDesc = "No";
		}
		this.lstEntryModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EntryModeEnabledDesc)));

		var result = this.dataService.ScanStationEntryModeUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					ss.EntryModeEnabled = !val;

					if (ss.EntryModeEnabled == true) {
						ss.EntryModeEnabledDesc = "Yes";
					} else {
						ss.EntryModeEnabledDesc = "No";
					}
					this.lstEntryModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EntryModeEnabledDesc)));
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateExitMode(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == false) {
			Msg = "Turning off Exit Mode means it will no longer show up in the menu. Are you sure you want to disable Exit Mode for " + ss.ScanStation + "?";
		} else {
			Msg = "Are you sure you want to turn on Exit Mode for " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Exit Mode",
			icon: "fa",
			accept: () => {
				this.onFinishUpdateExitMode(ss, val);
			},
			reject: () => {
				ss.ExitModeEnabled = !val;
				if (ss.ExitModeEnabled == true) {
					ss.ExitModeEnabledDesc = "Yes";
				} else {
					ss.ExitModeEnabledDesc = "No";
				}
			},
		});
	}

	onFinishUpdateExitMode(ss, val) {
		this.Processing = true;

		ss.ExitModeEnabled = val;
		if (ss.ExitModeEnabled == true) {
			ss.ExitModeEnabledDesc = "Yes";
		} else {
			ss.ExitModeEnabledDesc = "No";
		}
		this.lstExitModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.ExitModeEnabledDesc)));

		var result = this.dataService.ScanStationExitModeUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					ss.ExitModeEnabled = !val;

					if (ss.ExitModeEnabled == true) {
						ss.ExitModeEnabledDesc = "Yes";
					} else {
						ss.ExitModeEnabledDesc = "No";
					}
					this.lstExitModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.ExitModeEnabledDesc)));
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateMealMode(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == false) {
			Msg = "Turning off Meal Mode means it will no longer show up in the menu. Are you sure you want to disable Meal Mode for " + ss.ScanStation + "?";
		} else {
			Msg = "Are you sure you want to turn on Meal Mode for " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Meal Mode",
			icon: "fa",
			accept: () => {
				this.onFinishUpdateMealMode(ss, val);
			},
			reject: () => {
				ss.MealModeEnabled = !val;
				if (ss.MealModeEnabled == true) {
					ss.MealModeEnabledDesc = "Yes";
				} else {
					ss.MealModeEnabledDesc = "No";
				}
			},
		});
	}

	onFinishUpdateMealMode(ss, val) {
		this.Processing = true;

		ss.MealModeEnabled = val;
		if (ss.MealModeEnabled == true) {
			ss.MealModeEnabledDesc = "Yes";
		} else {
			ss.MealModeEnabledDesc = "No";
		}
		this.lstMealModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.MealModeEnabledDesc)));

		var result = this.dataService.ScanStationMealModeUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					ss.MealModeEnabled = !val;

					if (ss.MealModeEnabled == true) {
						ss.MealModeEnabledDesc = "Yes";
					} else {
						ss.MealModeEnabledDesc = "No";
					}
					this.lstMealModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.MealModeEnabledDesc)));
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateAccessMode(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == false) {
			Msg =
				"Turning off Access Mode means it will no longer show up in the menu. Are you sure you want to disable Access Mode for " + ss.ScanStation + "?";
		} else {
			Msg = "Are you sure you want to turn on Access Mode for " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Access Mode",
			icon: "fa",
			accept: () => {
				this.onFinishUpdateAccessMode(ss, val);
			},
			reject: () => {
				ss.AccessModeEnabled = !val;
				if (ss.AccessModeEnabled == true) {
					ss.AccessModeEnabledDesc = "Yes";
				} else {
					ss.AccessModeEnabledDesc = "No";
				}
			},
		});
	}

	onFinishUpdateAccessMode(ss, val) {
		this.Processing = true;

		ss.AccessModeEnabled = val;
		if (ss.AccessModeEnabled == true) {
			ss.AccessModeEnabledDesc = "Yes";
		} else {
			ss.AccessModeEnabledDesc = "No";
		}
		this.lstAccessModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.AccessModeEnabledDesc)));

		var result = this.dataService.ScanStationAccessModeUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					ss.AccessModeEnabled = !val;

					if (ss.AccessModeEnabled == true) {
						ss.AccessModeEnabledDesc = "Yes";
					} else {
						ss.AccessModeEnabledDesc = "No";
					}
					this.lstAccessModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.AccessModeEnabledDesc)));
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateTimeStampMode(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == false) {
			Msg =
				"Turning off Time Stamp Mode means it will no longer show up in the menu. Are you sure you want to disable Time Stamp Mode for " +
				ss.ScanStation +
				"?";
		} else {
			Msg = "Are you sure you want to turn on Time Stamp Mode for " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Time Stamp Mode",
			icon: "fa",
			accept: () => {
				this.onFinishUpdateTimeStampMode(ss, val);
			},
			reject: () => {
				ss.TimeStampModeEnabled = !val;
				if (ss.TimeStampModeEnabled == true) {
					ss.TimeStampModeEnabledDesc = "Yes";
				} else {
					ss.TimeStampModeEnabledDesc = "No";
				}
			},
		});
	}

	onFinishUpdateTimeStampMode(ss, val) {
		this.Processing = true;

		ss.TimeStampModeEnabled = val;
		if (ss.TimeStampModeEnabled == true) {
			ss.TimeStampModeEnabledDesc = "Yes";
		} else {
			ss.TimeStampModeEnabledDesc = "No";
		}
		this.lstTimeStampModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.TimeStampModeEnabledDesc)));

		var result = this.dataService.ScanStationTimeStampModeUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					ss.TimeStampModeEnabled = !val;

					if (ss.TimeStampModeEnabled == true) {
						ss.TimeStampModeEnabledDesc = "Yes";
					} else {
						ss.TimeStampModeEnabledDesc = "No";
					}
					this.lstTimeStampModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.TimeStampModeEnabledDesc)));
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateEventMode(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == false) {
			Msg = "Turning off Event Mode means it will no longer show up in the menu. Are you sure you want to disable Event Mode for " + ss.ScanStation + "?";
		} else {
			Msg = "Are you sure you want to turn on Event Mode for " + ss.ScanStation + "?";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Event Mode",
			icon: "fa",
			accept: () => {
				this.onFinishUpdateEventMode(ss, val);
			},
			reject: () => {
				ss.EventModeEnabled = !val;
				if (ss.EventModeEnabled == true) {
					ss.EventModeEnabledDesc = "Yes";
				} else {
					ss.EventModeEnabledDesc = "No";
				}
			},
		});
	}

	onFinishUpdateEventMode(ss, val) {
		this.Processing = true;

		ss.EventModeEnabled = val;
		if (ss.EventModeEnabled == true) {
			ss.EventModeEnabledDesc = "Yes";
		} else {
			ss.EventModeEnabledDesc = "No";
		}
		this.lstEventModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EventModeEnabledDesc)));

		var result = this.dataService.ScanStationEventModeUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					ss.EventModeEnabled = !val;

					if (ss.EventModeEnabled == true) {
						ss.EventModeEnabledDesc = "Yes";
					} else {
						ss.EventModeEnabledDesc = "No";
					}
					this.lstEventModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.EventModeEnabledDesc)));
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateRebuild(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		if (val == true) {
			Msg =
				"Requesting a rebuild will make the ScanStation rebuild the next time it starts up. For larger servers this can take a while. Are you sure you want to request " +
				ss.ScanStation +
				" perform a rebuild?";
		} else {
			Msg =
				"Are you sure you want to cancel requesting a rebuild for " +
				ss.ScanStation +
				"? If the preference was synced down it might do a rebuild anyways.";
		}

		this.confirmationService.confirm({
			key: "sstmain",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm " + (val == true ? "Request Rebuild" : "Cancel Rebuild Request"),
			icon: "fa",
			accept: () => {
				if (val == true) {
					this.onUpdateRebuildDoubleCheck(ss, val);
				} else {
					this.onFinishUpdateRebuild(ss, val);
				}
			},
			reject: () => {
				ss.IsSeverRequestRebuild = !val;
				if (ss.IsSeverRequestRebuild == true) {
					ss.IsSeverRequestRebuildDesc = "Yes";
				} else {
					ss.IsSeverRequestRebuildDesc = "No";
				}
			},
		});
	}

	onUpdateRebuildDoubleCheck(ss, val) {
		this.errorMessage = "";

		var Msg: string = "";

		Msg =
			"NOTE: Having too many ScanStations rebuild at once can significantly slow down large servers (and make all of the rebuilds take longer). THIS CAN HAPPEN if you request a whole school do a rebuild at night and NO ONE STARTS UP the program until the next morning. In that case you could request a rebuild, get the staff to turn the program OFF and back ON and let the rebuild run overnight (with the screen locked). Are you sure you want to continue?";

		this.confirmationService.confirm({
			key: "sstmaindoublecheck",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Request Rebuild",
			icon: "fa",
			accept: () => {
				this.onFinishUpdateRebuild(ss, val);
			},
			reject: () => {
				ss.IsSeverRequestRebuild = !val;
				if (ss.IsSeverRequestRebuild == true) {
					ss.IsSeverRequestRebuildDesc = "Yes";
				} else {
					ss.IsSeverRequestRebuildDesc = "No";
				}
			},
		});
	}

	onFinishUpdateRebuild(ss, val) {
		this.Processing = true;

		// ss.IsSeverRequestRebuild = val;
		// if (ss.IsSeverRequestRebuild == true) {
		// 	ss.IsSeverRequestRebuildDesc = "Yes";
		// } else {
		// 	ss.IsDecommissionedDesc = "No";
		// }
		// this.IsSeverRequestRebuildDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsSeverRequestRebuildDesc)));

		var result = this.dataService.ScanStationRebuildUpdate(ss.ScanStationID, val == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == false) {
					this.errorMessage = response.ErrorMessage;

					// ss.IsSeverRequestRebuild = !val;

					// if (ss.IsSeverRequestRebuild == true) {
					// 	ss.IsSeverRequestRebuildDesc = "Yes";
					// } else {
					// 	ss.IsSeverRequestRebuildDesc = "No";
					// }
					// this.IsSeverRequestRebuildDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsSeverRequestRebuildDesc)));
				} else {
					this.onRefresh();
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingFacility == true || this.LoadingCategory == true || this.LoadingScanStation == true || this.Processing == true;
	}

	IsSelected(colName: string) {
		for (var z = 0; z < this.SelectedColumns.length; z++) {
			var next = this.SelectedColumns[z];

			if (next.DataField == colName) {
				return true;
			}
		}

		return false;
	}

	//////////////////////////////////////////////////////////
}

export interface CategoryInfo {
	Category: string;
	lstColumns: ColumnInfo[];
}

export interface ColumnInfo {
	ColumnName: string;
	Selected: boolean;
	ReadOnly: boolean;
	DataField: string;
}
